import axios, { AxiosError } from 'axios';
import { getIdToken } from './liff';
import { getImpersonationToken } from './impersonation';
import type { ApiResponse } from '@meso/types';

const baseURL = (import.meta.env.VITE_API_BASE_URL as string) || '/api';

export const api = axios.create({
  baseURL,
  timeout: 15_000,
});

api.interceptors.request.use((config) => {
  // Prefer admin impersonation token if present — otherwise use LINE id_token
  const imp = getImpersonationToken();
  if (imp) {
    config.headers.Authorization = `AdminImp ${imp}`;
    return config;
  }
  const token = getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function apiCall<TData, TIn = unknown>(
  method: 'get' | 'post' | 'patch' | 'delete',
  path: string,
  body?: TIn,
): Promise<TData> {
  try {
    const res = await api.request<ApiResponse<TData>>({
      method,
      url: path,
      data: body,
    });
    if (!res.data.ok) throw new Error(res.data.error.message);
    return res.data.data;
  } catch (err) {
    if (err instanceof AxiosError && err.response?.data?.error) {
      throw new Error(err.response.data.error.message);
    }
    throw err;
  }
}
